<div class="summary-card" [ngClass]="{ 'is-missing': isMissing, 'is-attention': isAttention }">
  <div class="summary-card-logo" *ngIf="!isAttention">
    <div class="card-logo">
      <img *ngIf="info.imgSrc" src="assets/icons/{{ info.imgSrc }}.svg" alt="{{ info.title | translate }}" />
    </div>
  </div>
  <div class="summary-card-content">
    <div class="summary-card-header">
      <div [style.display]="'flex'">
        <img *ngIf="isAttention" src="/assets/icons/attention.svg" class="atten-icon" />
        <h5>{{ info.title | translate }}</h5>
      </div>

      <div class="summary-card-edit" *ngIf="canEdit || canRemove">
        <button class="btn btn-link mr-2" *ngIf="canRemove" (click)="entityRemove.emit()"><i class="fa fa-trash"></i></button>

        <button class="btn btn-link" *ngIf="canEdit" (click)="gotoEdit()"><i class="fa fa-pencil"></i></button>
      </div>
    </div>
    <ng-container *ngIf="isArray; then lIsArray; else lIsNotArray"></ng-container>
  </div>
</div>
<!-- once -->
<ng-template #lIsNotArray>
  <div class="container-card-body">
    <ng-container *ngIf="isMissing">
      <div class="row">
        <div class="col-12">{{ "LABELS.ISF_ENTITY_IS_MISSING" | translate }}</div>
      </div>
    </ng-container>
    <ng-container *ngIf="!isMissing">
      <isf-entity-details [isfEntity]="isfEntity" [code]="isfEntitySum?.code"></isf-entity-details>
    </ng-container>
  </div>
</ng-template>
<!-- array -->
<ng-template #lIsArray>
  <div class="container-card-body">
    <ng-container *ngIf="isMissing">
      <div class="row">
        <div class="col-12">{{ "LABELS.ISF_ENTITY_IS_MISSING" | translate }}</div>
      </div>
    </ng-container>
    <ng-container *ngIf="isAttention">
      <div class="row">
        <div class="col-12">{{ "INFO." + isfEntitySum.code + ".IS_ATTENTION_1" | translate }}</div>
        <div class="col-12">{{ "INFO.CS.IS_ATTENTION_2" | translate }}</div>
      </div>
    </ng-container>
    <ng-container *ngIf="isfEntitySum.code === enumEntityModelCode.HTS">
      <div class="hts-block" *ngFor="let invoiceEntity of isfEntities; let inx = index">
        <isf-hts-details [sequence]="inx + 1" [invoiceEntity]="invoiceEntity" [showHtsDescription]="showHtsDescription"></isf-hts-details>
      </div>
    </ng-container>
    <ng-container *ngIf="isfEntitySum.code !== enumEntityModelCode.HTS">
      <div class="mf-block" *ngFor="let isfEntity of isfEntities">
        <isf-entity-details [isfEntity]="isfEntity" [code]="isfEntitySum?.code"></isf-entity-details>
      </div>
    </ng-container>
  </div>
</ng-template>
